import { useEffect, useLayoutEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { TopBar } from "./TopBar";
import { UploaderProvider } from "@/context/UploaderContext";
import { PendingScreen } from "./PendingScreen";
import { useSpace } from "@/context/SpaceContext";

const allowedSpaces = () => ["all"];

export const AppShell = () => {
  const { user } = useAuth();
  const { space, setSpace } = useSpace();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!user) return;
    const ok = allowedSpaces(user).includes(space) || (user.role === "admin" && space.startsWith("user:"));
    if (!ok) setSpace("all");
  }, [user, space, setSpace]);
  useLayoutEffect(() => { window.scrollTo(0, 0); }, [pathname]); // Library restores its own position afterwards
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-white"><Loader2 className="animate-spin" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.blocked || !["family", "admin"].includes(user.role)) return <PendingScreen />;
  return (
    <UploaderProvider>
    <div className="min-h-screen" data-testid="app-shell">
      <TopBar />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
    </UploaderProvider>
  );
};
